// UT Dallas's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026 Undergraduate Catalog's Undergraduate Programs page
// (catalog.utdallas.edu/2026/undergraduate/programs), which lists every
// bachelor's program under the school that offers it. One line per degree
// program (BA or BS, as the catalog's own program list writes them);
// concentrations (Literature, Media Arts and Design, Visual and Performing
// Arts, Business Administration, Education), the prescribed double majors,
// minors and certificates are left out. Computational and Geospatial
// Science, Cybersecurity Technology and Policy and Data Science appear under
// both schools that list them, as the catalog does. The catalog's main list
// spells "School of Natural Science and Mathematics"; its section heading
// says "Natural Sciences", used here. The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "university-of-texas-at-dallas",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UT Dallas's official 2026 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Concentrations, the prescribed double majors, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Harry W. Bass Jr. School of Arts, Humanities, and Technology",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Animation and Games",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Literature",
                    "degree": "BA"
                },
                {
                    "name": "Media Arts and Design",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Professional Communication and Digital Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Visual and Performing Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Behavioral and Brain Sciences",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Child Learning and Development",
                    "degree": "BS"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Economic, Political and Policy Sciences",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "International Political Economy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Computational and Geospatial Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity Technology and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Geospatial Information Sciences",
                    "degree": "BS"
                },
                {
                    "name": "International Political Economy",
                    "degree": "BS"
                },
                {
                    "name": "Public and Nonprofit Management",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability Planning and Policy",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Erik Jonsson School of Engineering and Computer Science",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Engineering",
                    "degree": "BA"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computational and Geospatial Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity Technology and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS",
                    "note": "Offered jointly by the Department of Mathematical Sciences and the Department of Computer Science."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Systems Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Interdisciplinary Studies",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Education",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Education",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Studies",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Naveen Jindal School of Management",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics and Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Information Systems and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity and Risk Management",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Global Business",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management and Analytics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Natural Sciences and Mathematics",
            "source": {
                "label": "UT Dallas 2026 Undergraduate Catalog, Undergraduate Programs",
                "url": "https://catalog.utdallas.edu/2026/undergraduate/programs"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS",
                    "note": "Offered jointly by the Department of Mathematical Sciences and the Department of Computer Science."
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
